Namespace 'Monitoring.Reports.Publications'

class Monitoring.Reports.Publications.FacebookReportView extends Backbone.View

  className: 'publications-report'

  initialize: (@options = {}, @header) ->

    # nothing to do
  build: ->
    @trigger 'download-pdf:toggle', disabled: true
    @$('#build').prop('disabled', true)
    $('.publications-report > section').remove()
    sections = []
    if @header.include_page_resumen()
      section_options = $.extend({}, @options, { title: 'page_resumen_section' })
      @pageResumenView = new Monitoring.Reports.Publications.Sections.PageResumenView(section_options, @header)
      sections.push(@pageResumenView)
    if @has_summary()
      section_options = $.extend({}, @options, { title: 'summary' })
      @summary_view = new Monitoring.Reports.Publications.Sections.SummaryView(section_options, @header)      
      sections.push(@summary_view)
    if @header.include_page_reach_evolution()
      section_options = $.extend({}, @options, { title: 'page_reach_section' })
      @pageAnalyticsView = new Monitoring.Reports.Publications.Sections.PageReachView(section_options, @header)
      sections.push(@pageAnalyticsView)
    if @header.include_page_fans_evolution()
      section_options = $.extend({}, @options, { title: 'page_fans_section' })
      @pageFansView = new Monitoring.Reports.Publications.Sections.PageFansView(section_options, @header)
      sections.push(@pageFansView)
    if @has_comments_metrics()
      section_options = $.extend({}, @options, { title: 'comments-metrics' })
      @comments_metrics_view = new Monitoring.Reports.Publications.Sections.CommentsMetricsView(section_options, @header)
      sections.push(@comments_metrics_view)
    if @hasCustomSections()
      @addCustomSectionToRender(sections)
    if @has_rankings()
      section_options = $.extend({}, @options, { title: 'rankings' })
      @rankings_view = new Monitoring.Reports.Publications.Sections.RankingsView(section_options)
      sections.push(@rankings_view)
    
    section_options = $.extend({}, @options, { title: 'contents' })
    @contents_view = new Monitoring.Reports.Publications.Sections.ContentsView(section_options, @header)
    sections.push(@contents_view)
    for section in sections
      section.render()
      @$el.append(section.el)
    @fetch_analytics()
    @fetch_page_analytics() if @pageAnalyticsView || @pageFansView || @pageResumenView
    if @has_comments_metrics()
      @fetch_comments_analytics()
    @

  hasCustomSections: ->
    (@options.available_sections.length)>0

  addCustomSectionToRender:(sections)->
    optional_sections = @header.getSelectedSections()
    custom_sections_model = new Monitoring.Reports.Publications.Subsections.CustomSections(@options, @header)
    for section in optional_sections
      optional_section_title = @getName(section)
      optional_section_option = $.extend({}, @options, { title: optional_section_title })
      section_constructor = @getConstructor(section)
      selectedSubsectionsForThisSection = @getSubsectionsContructors(optional_section_title, custom_sections_model)
      optionalView = @constructSectionAndHisSelectedSubsection(section_constructor, selectedSubsectionsForThisSection, custom_sections_model)
      sections.push(optionalView)

  fetch_analytics: ->
    $.ajax
      type: 'post'
      url: '/monitoring/reports/publications/analytics'
      data:
        date_since: @header.getDateFrom()
        date_until: @header.getDateTo()
        content_type: @options.contents[0].type
        rankings_config: @rankings_config()
        contents: @_analyticsContents()
        fb_id: @options.contents[0].user
      success: @fill_results
      error: @fail
      complete: @completed

  fetch_page_analytics: ->
    $.ajax
      type: 'post'
      url: '/monitoring/reports/publications/facebook_page_analytics'
      data:
        date_since: @header.getPageDateFrom()
        date_until: @header.getPageDateTo()
        dimension: @header.getDimension()
        fb_id: @options.contents[0].user
      success: @fill_page_results
      error: @fail
      complete: @completed

  _analyticsContents: ->
    {id: content.content_id, tags: content.full_content.tags} for content in @options.contents

  fetch_comments_analytics: ->
    $.ajax
      type: 'post'
      url: '/monitoring/reports/publications/sentiment'
      data:
        date_since: @header.getDateFrom()
        date_until: @header.getDateTo()
        document_ids: (content.id for content in @options.contents)
        content_ids: (content.content_id for content in @options.contents)
        type: 'facebook'
        include_comment_replies: @header.include_comment_replies()
      success: @fill_comments_results
      error: @fail
      complete: @completed

  fill_results: (data) =>
    @fill_analytics(data.analytics)
    @fill_rankings(data.rankings) if @has_rankings()

  fill_page_results: (data) =>
    @pageAnalyticsView.fill_page_analytics(data.histograms) if @pageAnalyticsView
    @pageFansView.fill_page_analytics(data.histograms) if @pageFansView
    @pageResumenView.fill_page_resumen(data.resumen) if @pageResumenView

  fill_analytics: (data) ->
    @summary_view.fill_analytics(data) if @has_summary()
    @contents_view.fill_analytics(data)

  fill_rankings: (data) ->
    @rankings_view.fill_rankings(data, @options.contents) if @has_rankings()

  fill_comments_results: (data) =>
    @comments_metrics_view.fill_analytics(data, @options.contents)

  fail: =>
    @summary_view.fail()
    @contents_view.fail()
    @rankings_view.fail() if @has_rankings()

  completed: =>
    @$('#build').prop('disabled', false)
    @trigger 'download-pdf:toggle', disabled: false

  has_summary: ->
    @header.has_summary_section()

  has_rankings: ->
    @rankings_config().length > 0

  has_comments_metrics: ->
    @header.has_comments_metrics()

  rankings_config: ->
    @header.rankings_config()

  getSubsectionsContructors: (optional_section_title, custom_sections_model) ->
    subsections_contructors = []
    optional_subsections = @header.getSelectedSubsections(optional_section_title)
    for subsection in optional_subsections
        optional_subsection_title = @getName(subsection)
        subsection_constructor = @getConstructor(subsection)
        optional_section_option = $.extend({}, @options, { title: optional_subsection_title })
        optional_subsection_view = new subsection_constructor(optional_section_option, @header, custom_sections_model)
        subsections_contructors.push(optional_subsection_view)

    subsections_contructors

  constructSectionAndHisSelectedSubsection: (section, subsections, optional_sections_model)->
    optional_section_view = new section(subsections, optional_sections_model)

  _export: (format) ->
    showNotice('Exporting process started')
    params = {
      format: format
      sections: this.$('report').context.outerHTML
      type: 'publications'
      sections_count: this.$('.delimiter').length
    }
    $.post('/monitoring/reports/exporter/export', params, (response) =>
      @jobId = response.job_id
      @_askIfCompleted()
    )

  getName:(section) ->
    _.keys(section)[0]

  getConstructor: (section) ->
    _.values(section)[0]


  _askIfCompleted: =>
    $.get('/monitoring/reports/exporter/export_finish', {job_id: @jobId}, (response) =>
      if response.status == 'completed'
        showNotice('Downloading')
        @trigger 'download-pdf:toggle', disabled: false
        window.open(
          response.link,
          '_blank');

      else if response.status == 'failed'
        showError('Exportation failed. If this error persists, please contact us.')

      else if response.status != 'not_found'
        setTimeout(@_askIfCompleted, 2000)
    )
